import React from "react";
import { useField } from "formik";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const InputField = ({
  disable,
  required,
  label,
  isPassword,
  showPassword,
  onPasswordToggle,
  className,
  maxDate, // Pass maxDate prop for date restriction
  maxValue,
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <div className={`form-control flex flex-col gap-2 p-1 text-xs ${className}`}>
      <label htmlFor={props.id || props.name} className="font-medium">
        {label}
        {required && <span className="text-red-600 font-bold">*</span>}
      </label>
      <div className="flex flex-row items-center bg-white border border-gray-300">
        <input
          className={`text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 ${className}`}
          min={0}
          {...field}
          {...props}
          autoComplete="off"
          disabled={disable}
          max={maxValue ?? props.type === "date" ? maxDate : undefined} // Apply max date if input type is date
        />
        {isPassword ? showPassword ? <FaEyeSlash className="ml-4 mr-4" onClick={onPasswordToggle} /> : <FaEye className="ml-4 mr-4" onClick={onPasswordToggle} /> : <></>}
      </div>
      {required && meta.touched && meta.error ? (
        <div className="text-red-600">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default InputField;
